import React, { forwardRef } from "react";
const SvgStoryArrow = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20.6667 6.66667 10.6667 16l10 9.3333", stroke: "currentColor", strokeWidth: 2.4, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgStoryArrow);
export default ForwardRef;
